export const GET_RYFT_PAYMENT_SESSION_DATA = "GET_RYFT_PAYMENT_SESSION_DATA"
export const CLEAR_RYFT_PAYMENT_SESSION_DATA = "CLEAR_RYFT_PAYMENT_SESSION_DATA"